var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('base-crud',{attrs:{"crudName":"Mensagens do SAC","newText":"Nova Mensagem","table":_vm.contactUsTable,"columns":_vm.columns,"options":_vm.options,"endPoint":_vm.endPoint,"enableAdd":false,"enableEdit":false,"enableDelete":true,"enableView":true}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-06ab6dd3","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContactUs/Crud.vue
// module id = null
// module chunks = 